import { AreaField, Card } from "../Field";

export default function AutobusiTab({ record, update }) {
  const a = record.autobusi;
  const set = (k) => (v) => update({ autobusi: { ...a, [k]: v } });
  return (
    <div className="grid gap-5 lg:grid-cols-2">
      <Card title="Dolasci autobusa" subtitle="Svaki red je novi unos, npr. 7:45 - linija Ivanovac" badge="Jutro">
        <AreaField label="Evidencija dolazaka" value={a.dolasci} onChange={set("dolasci")} testId="form-autobusi-dolasci-input" rows={10} placeholder={"7:40 - linija 1, sve uredno\n7:55 - linija 2, kašnjenje 5 min"} />
      </Card>
      <Card title="Odlasci autobusa" subtitle="Svaki red je novi unos, npr. 13:15 - linija Ivanovac" badge="Poslijepodne">
        <AreaField label="Evidencija odlazaka" value={a.odlasci} onChange={set("odlasci")} testId="form-autobusi-odlasci-input" rows={10} placeholder={"13:10 - linija 1, sve uredno\n14:00 - linija 2, sve uredno"} />
      </Card>
    </div>
  );
}
